import React, { useState, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { getMyProfile } from '../../api/userProfileApi';
import { listCampuses } from '../../api/campusPortalApi';
import AssessmentScheduleManagement from '../AssessmentScheduleManagement/AssessmentScheduleManagement';

const PortalAssessmentScheduleManagement = () => {
  const auth = useAuth();
  const [userCampusName, setUserCampusName] = useState(null);

  useEffect(() => {
    const loadCampusName = async () => {
      if (!auth.isAuthenticated) return;
      try {
        const profile = await getMyProfile();
        const campusId = profile?.campusId || (profile?.campusIds?.length ? profile.campusIds[0] : null);
        if (campusId) {
          const campuses = await listCampuses();
          const campus = campuses.find(c => c.id === campusId);
          if (campus) {
            setUserCampusName(campus.name);
          }
        }
      } catch (err) {
        console.error('Error loading campus name:', err);
      }
    };
    loadCampusName();
  }, [auth.isAuthenticated]);

  return (
    <AssessmentScheduleManagement
      backPath="/portal"
      userCampusName={userCampusName}
    />
  );
};

export default PortalAssessmentScheduleManagement;
